// src/components/ProductosPDF.js
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import logo from '../images/LOGO DEFINITIVO POLLOS TEOOO.png'; // Asegúrate de que la ruta al logo es correcta

// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 40,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 20,
  },
  logo: {
    width: 120,
    height: 120,
  },
  headerText: {
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  title: {
    fontSize: 26,
    color: '#002B44',
    fontWeight: 'bold',
    marginBottom: 5,
  },
  subtitle: {
    fontSize: 16,
    color: '#555555',
    marginBottom: 10,
  },
  date: {
    fontSize: 12,
    color: '#777777',
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 18,
    color: '#002B44',
    fontWeight: 'bold',
    marginBottom: 10,
    backgroundColor: '#f8f9fa',
    padding: 8,
    borderRadius: 4,
  },
  table: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#DDDDDD',
    borderRadius: 4,
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: 'row',
    width: '100%',
  },
  tableHeader: {
    backgroundColor: '#002B44',
    color: '#FFFFFF',
  },
  tableCell: {
    padding: 6,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#DDDDDD',
    fontSize: 9,
  },
  nameCell: {
    width: '25%',
  },
  descriptionCell: {
    width: '45%',
    fontSize: 8,
  },
  qtyCell: {
    width: '15%',
    textAlign: 'center',
  },
  priorityCell: {
    width: '15%',
    textAlign: 'center',
    color: '#FF0000',
  },
  oddRow: {
    backgroundColor: '#F9F9F9',
  },
  evenRow: {
    backgroundColor: '#FFFFFF',
  },
  priorityRow: {
    backgroundColor: '#FFFfEF', // Color de fondo para filas prioritarias
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0, 
    textAlign: 'center',
    fontSize: 10,
    color: '#777777',
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: '#DDDDDD',
  },
});

const formatDescription = (description) => {
  if (!description) return '';
  return description
    .split(',')
    .map(item => {
      const [num, sabor] = item.split('::').map(s => s.trim());
      return `${num}: ${sabor}`;
    })
    .join('\n');
};

// Componente para el PDF
const ProductosPDF = ({ data }) => {
  // Asegurarse de que los arrays existan, si no, usar arrays vacíos
  const hamburguesas = data?.hamburguesas || [];
  const products = data?.products || [];

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Encabezado con logo y fecha */}
        <View style={styles.header}>
          <Image src={logo} style={styles.logo} />
          <View style={styles.headerText}>
            <Text style={styles.title}>Listado de Productos</Text>
            <Text style={styles.date}>Generado el: {new Date().toLocaleDateString()}</Text>
          </View>
        </View>
        
        {/* Sección de Hamburguesas */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Hamburguesas</Text>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <Text style={[styles.tableCell, styles.nameCell]}>Nombre</Text>
              <Text style={[styles.tableCell, styles.descriptionCell]}>Descripción</Text>
              <Text style={[styles.tableCell, styles.qtyCell]}>Cantidad</Text>
              <Text style={[styles.tableCell, styles.qtyCell]}>Prioridad</Text>
            </View>
            
            {hamburguesas.map((producto, index) => (
              <View
                key={index}
                style={[
                  styles.tableRow,
                  index % 2 === 0 ? styles.evenRow : styles.oddRow,
                  producto?.Order?.priority && styles.priorityRow,
                ]}
              >
                <Text style={[styles.tableCell, styles.nameCell]}>
                  {producto?.name || ''}
                </Text>
                <Text style={[styles.tableCell, styles.descriptionCell]}>
                  {formatDescription(producto?.description)}
                </Text>
                <Text style={[styles.tableCell, styles.qtyCell]}>
                  {producto?.total_quantity || 0}
                </Text>
                <Text style={[styles.tableCell, styles.priorityCell]}>
                  {producto?.Order?.priority ? "★ Prioritario" : ""}
                </Text>
              </View>
            ))}
          </View>
        </View>

        {/* Sección de Otros Productos */}
        <View style={styles.section}>
          <Text style={styles.sectionTitle}>Otros Productos</Text>
          <View style={styles.table}>
            <View style={[styles.tableRow, styles.tableHeader]}>
              <Text style={[styles.tableCell, styles.nameCell]}>Nombre</Text>
              <Text style={[styles.tableCell, styles.descriptionCell]}>Descripción</Text>
              <Text style={[styles.tableCell, styles.qtyCell]}>Cantidad</Text>
              <Text style={[styles.tableCell, styles.qtyCell]}>Prioridad</Text>
            </View>
            
            {products.map((producto, index) => (
              <View
                key={index}
                style={[
                  styles.tableRow,
                  index % 2 === 0 ? styles.evenRow : styles.oddRow,
                  producto?.Order?.priority && styles.priorityRow,
                ]}
              >
                <Text style={[styles.tableCell, styles.nameCell]}>
                  {producto?.name || ''}
                </Text>
                <Text style={[styles.tableCell, styles.descriptionCell]}>
                  {formatDescription(producto?.description)}
                </Text>
                <Text style={[styles.tableCell, styles.qtyCell]}>
                  {producto?.total_quantity || 0}
                </Text>
                <Text style={[styles.tableCell, styles.priorityCell]}>
                  {producto?.Order?.priority ? "★ Prioritario" : ""}
                </Text>
              </View>
            ))}
          </View>
        </View>
        
        {/* Pie de página */}
        <Text style={styles.footer}>
          PollosTeo | Todos los derechos reservados
        </Text>
      </Page>
    </Document>
  );
};

export default ProductosPDF;